/**
 * @(#)2019/8/06.
 * Modal 模态框-用于弹出各种处理
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React from "react";
import Modal from "./Modal";
import Drawer from "./Drawer";
import { get } from "../../utils/index";
import { l } from "../../config/language";
import { YxComponent, Connection } from "../YxComponent";

let defaultProps = () => {
  return {
    popupType: "modal", //弹窗类型，默认为模态框   modal/drawer
    okText: null, //确定按钮的文字，如果是null   drawer模式下的确定按钮会被隐藏
  };
};
@Connection(defaultProps)
export default class extends YxComponent {
  constructor(...args) {
    super(...args);
  }

  render() {
    let tmpProps = {
      okText: l("YxModal.ot", this),
      cancelText: l("YxModal.ct", this),
      ...this.props,
    };
    let close = get(tmpProps, "onClose", () => {});
    if (tmpProps.popupType == "drawer") {
      tmpProps.onClose = (a, b) => {
        get(tmpProps, "onCancel", () => {})(a, b);
        close(a, b);
      };
    }
    return (
      <div>
        {tmpProps.popupType == "modal" ? <Modal {...tmpProps} /> : ""}
        {tmpProps.popupType == "drawer" ? <Drawer {...tmpProps} /> : ""}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxModal/YxModal.js